import { create } from 'zustand'
import { FormsModel } from '../../components/stores/models/StoreDetailModel'

interface FormIncedenceStore {
    formIncidence: null | FormsModel
    canFormIncidence: boolean
    setFormIncidence: (formIncidence: FormsModel) => void
    clearDataFormIncidence: () => void
}

export const useFormIncidenceStore = create<FormIncedenceStore>((set) => ({
    canFormIncidence: false,
    formIncidence: null,
    setFormIncidence: (formIncidence) => set({
        formIncidence,
        canFormIncidence: true
    }),
    clearDataFormIncidence: () => set({
        formIncidence: null,
        canFormIncidence: false
    })
}))

